import { Button, makeStyles, Textarea } from "@fluentui/react-components";
import { Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from "@fluentui/react-dialog";
import { Dismiss24Regular } from "@fluentui/react-icons";
import React, { useState } from "react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (comment: string) => void;
};

export const FeedbackDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [comment, setComment] = useState("");
  const styles = useStyles();

  const handleSubmit = () => {
    onSubmit(comment);
    setComment("");
    onClose();
  };

  const handleClose = () => {
    setComment("");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(_event, data) => !data.open && handleClose()}>
      <DialogSurface>
        <DialogTitle
          action={
            <Button
              appearance="subtle"
              aria-label="close"
              icon={<Dismiss24Regular />}
              onClick={handleClose}
            />
          }
        >
          評価をコメント
        </DialogTitle>
        <DialogBody>
          <DialogContent>
            <Textarea
              className={styles.textArea}
              placeholder="コメントを入力してください"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={handleClose}>
              キャンセル
            </Button>
            <Button appearance="primary" onClick={handleSubmit}>
              コメントを送信
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

const useStyles = makeStyles({
  textArea: {
    width: "100%",
    minHeight: "120px",
  },
});
